import type { ReactNode } from 'react';
import styles from './EmptyState.module.css';

export interface EmptyStateProps {
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
}

export function EmptyState({ icon = '🕯️', title, description, actions }: EmptyStateProps) {
  return (
    <div className={styles.empty}>
      <div className={styles.icon} aria-hidden>
        {icon}
      </div>
      <h3 className={styles.title}>{title}</h3>
      {description != null && <p className={styles.desc}>{description}</p>}
      {actions != null && <div className={styles.actions}>{actions}</div>}
    </div>
  );
}
